export default __webpack_public_path__ + "static/media/minnesotaVikingsVideo-2x.96118820.jpg";